<template>
  <div hidden>
    <login />
    <glh-header />
    <template v-if="isLogin">
      <div class="bg-img"></div>
      <div class="bg">
        <section class="my-container">
          <UserHeader class="user-header" />
          <div class="bottom-box">
            <div class="navs-box">
              <Navs />
            </div>
            <div class="view">
              <nuxt />
            </div>
          </div>
        </section>
      </div>
    </template>
    <template v-else>
      <div class="login-first">请先登录</div>
    </template>
    <glh-footer />
  </div>
</template>
<script>
import glhFooter from "~/components/public/glh-footer";
import glhHeader from "~/components/public/glh-header";
import Login from "~/components/public/login";
import Navs from "~/components/my/navs";
import UserHeader from "~/components/my/user-header";
import { mapGetters } from "vuex";

export default {
  components: {
    glhFooter,
    glhHeader,
    Login,
    Navs,
    UserHeader
  },
  computed: {
    ...mapGetters("user", ["isLogin"])
  },
  mounted() {
    this.$el.removeAttribute('hidden')
  }
};
</script>

<style lang="less" scoped>
.bg-img {
  width: 100%;
  height: 240px;
  background: no-repeat 100%
    url("https://cdn.gelonghui.com/static/web/my-bg.png");
}

.bg {
  background: #f6f6f6;
}

.my-container {
  position: relative;
  bottom: 100px;
  width: 1200px;
  margin: 0 auto;
  background-color: #f6f6f6;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  .user-header {
    background: #fff;
  }

  .bottom-box {
    display: flex;
    justify-content: space-between;

    margin-top: 24px;
    .navs-box {
      width: 230px;
      height: 400px;
    }

    .view {
      width: 950px;
      min-height: 600px;
      background: #fff;
    }
  }
}

.login-first {
  display: flex;
  justify-content: center;
  align-items: center;

  height: 600px;

  font-size: 18px;
}
</style>
